import React from 'react'
import Recorder from 'audio-recorder-polyfill'
import mpegEncoder from 'audio-recorder-polyfill/mpeg-encoder'

export default class AudioRecorder extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isRecording: false,
            blobURL: '',
            progress: 0,
            triedRecording: false
        }
        this.recorder = null
        this.onSuccess = this.onSuccess.bind(this)
        this.start = this.start.bind(this)
        this.stop = this.stop.bind(this)
        this.startTimer = this.startTimer.bind(this)
    }
    startTimer() {
        this.startTime = performance.now()
        this.trialTimer = setInterval(() => {
            const {timeLimit} = this.props
            const timeLimitInMs = timeLimit * 1000
            this.tick()
            if (this.elapsedTime >= timeLimitInMs) {
                this.stop()
            } else {
                this.setState({
                    progress: (this.elapsedTime / timeLimitInMs) * 100})
            }
        }, 50)
    }
    stopTimer() {
        clearInterval(this.trialTimer)
        this.setState({progress: 0})
    }
    componentWillUnmount() {
        this.stopTimer()
    }
    tick() {
        this.elapsedTime = performance.now() - this.startTime
    }
    onSuccess(stream) {
        Recorder.encoder = mpegEncoder
        Recorder.prototype.mimeType = 'audio/mpeg'
        this.recorder = new Recorder(stream)

        let chunks = []
        this.recorder.audioURL = null

        this.recorder.addEventListener('dataavailable', function(e) {
            if (e.data.size > 0) {
                chunks.push(e.data)
            }
        })

        this.recorder.addEventListener('stop', () => {
            const blob = new Blob(chunks, {'type': 'audio/mpeg'})
            chunks = []
            const audioURL = URL.createObjectURL(blob)
            this.setState({blobURL: audioURL})
        })

        this.recorder.start()
    }
    start() {
        navigator.mediaDevices.getUserMedia({audio: true})
            .then(this.onSuccess)
            .then(this.startTimer)
            //.then((audioURL) => this.setState({blobURL: audioURL}))
            .catch(err => console.log(err.message))

        this.setState({isRecording: true})
    }
    stop() {
        if(this.recorder){this.recorder.stop()}
        this.stopTimer()
        this.setState({isRecording: false, triedRecording: true})
    }
    render(){
        const {isRecording, blobURL, progress, triedRecording} = this.state
        return (
            React.Children.map(this.props.children,
                child => React.cloneElement(child, {
                    start: this.start,
                    stop: this.stop,
                    isRecording,
                    progress,
                    blobURL,
                    triedRecording
                }))
        );
    }
}

